import { apiPost } from "./api";
export const Catalogos = {
	EstadoCivil: 1,
	Estados: 2,
	Generos: 3,
	Escolaridad: 4,
	Especialidades: 5,
	HistorialClinico_Enfermedades: 6,
	HistorialClinico_Parentesco: 7,
	HistorialClinico_PadecimientoActual: 8,
	HistorialClinico_PresentacionCetolan: 9
};
export default class ServicioCatalogos {
	static getCatalogo(catalogoID) {
		const cache = this.obtenerCatalogoCache(catalogoID);
		if (cache) {
			return new Promise(resolve => {
				resolve(cache);
			});
		}
		const data = { Catalogos: [{ CatalogoID: catalogoID }] };
		return apiPost("/catalogos/Obtener", data);
	}

	static obtenerCatalogoCache(catalogo) {
		const cat = localStorage.getItem(`cat_${catalogo}`);
		if (cat) {
			return JSON.parse(cat);
		} else {
			return null;
		}
	}

	static catalogos = {
		ResultadosBioquimicos: {
			FuncionRenal: [
				{
					Nombre: "Creatinina en orina",

					Referencia: "80-160 Mg/dl",
					LimiteInferior: 80,
					LimiteSuperior: 160
				},
				{
					Nombre: "Creatinina sérica",

					Referencia: "0.7-1.2 mg/dl",
					LimiteInferior: 0.7,
					LimiteSuperior: 1.2
				},
				{
					Nombre: "Volumen Urinario",

					Referencia: "600-1600 ml",
					LimiteInferior: 600,
					LimiteSuperior: 1600
				},
				{
					Nombre: "Dep Cr No corregida",

					Referencia: "Ml/Min"
				},
				{
					Nombre: "Dep Cr corregida",

					Referencia: "Ml/Min"
				},
				{
					Nombre: "Tasa de Filtración Glomerular CKD-EPI",

					Referencia: "Ml/Min/1.73m2"
				},
				{
					Nombre: "Cistatina C",

					Referencia: "Mg/Dl"
				},
				{
					Nombre: "Albúmina Urinaria",

					Referencia: "Mg/24 Hrs"
				},
				{
					Nombre: "Proteína Urinaria",

					Referencia: "Mg/24 Hrs"
				},
				{
					Nombre: "Nitrógeno Ureico Urinario",

					Referencia: "G/24 Hrs"
				}
			],
			QuimicaSanguinea: [
				{
					Nombre: "Glucosa",

					Referencia: "70-100 mg/dL",
					LimiteInferior: 70,
					LimiteSuperior: 100
				},
				{
					Nombre: "BUN",

					Referencia: "9-20 mg/dL",
					LimiteInferior: 9,
					LimiteSuperior: 20
				},
				{
					Nombre: "Urea",

					Referencia: "10-50 mg/dL",
					LimiteInferior: 10,
					LimiteSuperior: 50
				},
				{
					Nombre: "Ácido Úrico",

					Referencia: "3.4-7.9 mg/dL",
					LimiteInferior: 3.4,
					LimiteSuperior: 7.9
				},
				{
					Nombre: "Colesterol Total",

					Referencia: "<200 mg/dL",
					LimiteSuperior: 200
				},
				{
					Nombre: "Colesterol HDL",

					Referencia: ">40 mg/dL",
					LimiteInferior: 40
				},
				{
					Nombre: "Colesterol LDL",

					Referencia: "<100 mg/dL",
					LimiteSuperior: 100
				},
				{
					Nombre: "Triglicéridos",

					Referencia: "<150 mg/dL",
					LimiteSuperior: 150
				},
				{
					Nombre: "Proteínas Totales",

					Referencia: "6.4-8.3 g/dL",
					LimiteInferior: 6.4,
					LimiteSuperior: 8.3
				},
				{
					Nombre: "Albúmina",

					Referencia: "3.5-4.8 g/dL",
					LimiteInferior: 3.5,
					LimiteSuperior: 4.8
				},
				{
					Nombre: "Sodio",

					Referencia: "135-145 mEq/L",
					LimiteInferior: 135,
					LimiteSuperior: 145
				},
				{
					Nombre: "Potasio",

					Referencia: "3.6-5.5 mEq/L",
					LimiteInferior: 3.6,
					LimiteSuperior: 5.5
				},
				{
					Nombre: "Cloro",

					Referencia: "98-107 mEq/L",
					LimiteInferior: 98,
					LimiteSuperior: 107
				},
				{
					Nombre: "Calcio",

					Referencia: "8.6-10.2 mg/dL",
					LimiteInferior: 8.6,
					LimiteSuperior: 10.2
				},
				{
					Nombre: "Fósforo",

					Referencia: "2.6-4.8 mg/dL",
					LimiteInferior: 2.6,
					LimiteSuperior: 4.8
				},
				{
					Nombre: "Magnesio",

					Referencia: "1.6-2.5 mg/dL",
					LimiteInferior: 1.6,
					LimiteSuperior: 2.5
				},
				{
					Nombre: "HbA1c",

					Referencia: "6-7%",
					LimiteInferior: 6,
					LimiteSuperior: 7
				},
				{
					Nombre: "Hierrro",

					Referencia: "33-193 mcg/dL",
					LimiteInferior: 33,
					LimiteSuperior: 193
				},
				{
					Nombre: "Transferrina",

					Referencia: "200-360 mg/dL",
					LimiteInferior: 200,
					LimiteSuperior: 360
				},
				{
					Nombre: "UIBC",

					Referencia: "135-392 mcg/dL",
					LimiteInferior: 135,
					LimiteSuperior: 392
				},
				{
					Nombre: "Captación Hierro",

					Referencia: "250-450 mcg/dL",
					LimiteInferior: 250,
					LimiteSuperior: 450
				},
				{
					Nombre: "% sat Hierro",

					Referencia: "15-50%",
					LimiteInferior: 15,
					LimiteSuperior: 50
				},
				{
					Nombre: "25OHVitD",

					Referencia: "30-100 mcg/L",
					LimiteInferior: 30,
					LimiteSuperior: 100
				},
				{
					Nombre: "PTH",

					Referencia: "10-55 pg/mL",
					LimiteInferior: 10,
					LimiteSuperior: 55
				}
			],
			BiometriaHematica: [
				{
					Nombre: "Eritrocitos",

					Referencia: "4.04-6.13 mil/uL",
					LimiteInferior: 4.04,
					LimiteSuperior: 6.13
				},
				{
					Nombre: "Hemoglobina",

					Referencia: "12-16 g/dL",
					LimiteInferior: 12,
					LimiteSuperior: 16
				},
				{
					Nombre: "Hematócrito",

					Referencia: "37-47%",
					LimiteInferior: 37,
					LimiteSuperior: 47
				},
				{
					Nombre: "VCM",

					Referencia: "78-99 fL",
					LimiteInferior: 78,
					LimiteSuperior: 99
				},
				{
					Nombre: "HCM",

					Referencia: "27-31 pg",
					LimiteInferior: 27,
					LimiteSuperior: 31
				},
				{
					Nombre: "Leucocitos",

					Referencia: "3.6-11.6 miles/uL",
					LimiteInferior: 3.6,
					LimiteSuperior: 11.6
				},
				{
					Nombre: "Linfocitos",

					Referencia: "16.5-49.6%",
					LimiteInferior: 16.5,
					LimiteSuperior: 49.6
				}
			],
			ExamenGeneralOrina: [
				{
					Nombre: "pH",

					Referencia: "5-8",
					LimiteInferior: 5,
					LimiteSuperior: 8
				},
				{
					Nombre: "Densidad",

					Referencia: "1.01-1.025",
					LimiteInferior: 1.01,
					LimiteSuperior: 1.025
				},
				{
					Nombre: "Nitritos",

					Referencia: "neg",
					LimiteSuperior: 0.1
				},
				{
					Nombre: "Urobilinógeno",

					Referencia: "neg",
					LimiteSuperior: 0.1
				},
				{
					Nombre: "Proteínas",

					Referencia: "0-30 mg/dL",
					LimiteInferior: 0,
					LimiteSuperior: 30
				},
				{
					Nombre: "Glucosa",

					Referencia: "neg",
					LimiteSuperior: 0.1
				},
				{
					Nombre: "Cetonas",

					Referencia: "neg",
					LimiteSuperior: 0.1
				},
				{
					Nombre: "Hemoglobina",

					Referencia: "neg",
					LimiteSuperior: 0.1
				},
				{
					Nombre: "Leucocitos",

					Referencia: "0.6 xC",
					LimiteSuperior: 0.1
				},
				{
					Nombre: "Eritrocitos",

					Referencia: "0.2 xC",
					LimiteSuperior: 0.1
				},
				{
					Nombre: "Bacterias",

					Referencia: "neg",
					LimiteSuperior: 0.1
				}
			]
		}
	};
}
